import getTestsResponse from './get-tests.json';
import sendOtpResponse from './send-otp.json';
import verifyOtpResponse from './verify-otp.json';

class MockService {
  static async mockResponse(data) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(data);
      }, 500); // Simulate network delay
    });
  }

  static async getTests() {
    return this.mockResponse(getTestsResponse);
  }

  static async sendOtp(mobile, courseType) {
    const response = { ...sendOtpResponse };
    response.data.mobile = mobile;
    return this.mockResponse(response);
  }

  static async verifyOtp(mobile, otp, courseType) {
    const response = { ...verifyOtpResponse };
    response.data.mobile = mobile;
    response.data.courseType = courseType;
    response.data.user.mobile = mobile;
    return this.mockResponse(response);
  }
}

export default MockService; 